import React from "react";
import '../../sass/components/flexibleModules/_components.tableWithGridSectionComponent.scss';

const TableWithGridSectionComponent = ({ data }) => {

    const scrollToRefLink = (ref) => {
        if (ref) {
            window.scrollTo({
                top: document.querySelector(ref).offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <div className={`cp-tableWithGridSection ${data.overrideClass}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-tableWithGridSection__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.tableWithGridSectionHeader &&
                    <h2>{data.tableWithGridSectionHeader}</h2>
                }
                {data.tableWithGridSectionRepeaterField &&
                    <>
                        {data.tableWithGridSectionRepeaterField.map((table, index) => (
                            <div className="cp-tableWithGridSection__table" key={index}>
                                {table.category &&
                                    <span className="cp-tableWithGridSection__table-category">{table.category}</span>
                                }
                                {table.titleRepeaterFields &&
                                    <div className="cp-tableWithGridSection__table-gridHeader l--flex">
                                        {table.titleRepeaterFields.map((tabletitle, index) => (
                                            <React.Fragment key={index}>
                                                {tabletitle.title &&
                                                    <span>{tabletitle.title}</span>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                                }
                                {table.columnsRepeaterFields &&
                                    <div className="cp-tableWithGridSection__table-gridLinks l--flex">
                                        {table.columnsRepeaterFields.map((tablegrid, index) => (
                                            <div className="" style={{ backgroundColor: `${tablegrid.backgroundColor}` }} key={index}>
                                                {tablegrid.links &&
                                                    <>
                                                        {tablegrid.links.map((linksrepeat, index) => (
                                                            <button data-anchor={linksrepeat.link.url} onClick={() => scrollToRefLink(`.${linksrepeat.link.url}`)} key={index}>{linksrepeat.link.title}</button>
                                                        ))}
                                                    </>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    );
}

export default TableWithGridSectionComponent;